import React, { Component, Fragment } from "react";
import DispatchProps from "../../../utils/DispatchProps";
import Actions from "../../../redux/Actions";
import OnboardHelpBox from "./OnboardHelpBox";
import OnboardTimeline, {OnboardTimelineItem} from "./OnboardTimeline";
import OnboardNavigation from "./OnboardNavigation";
import { IRootState } from "../../../store";
import { connect } from "react-redux";
import { History } from "history";
import { SchoolWorkloadConfig } from "../../../models/SchoolWorkloadConfig";
import ApiService from "../../ApiService";
import * as _ from "lodash";
import { MessageBarType, Checkbox, Stack } from "office-ui-fabric-react";
import School from "../../../models/School";

interface OnboardExtraTeamPageProps {
    tenantId: string;
    schoolCode: string;

    apiService: ApiService;
    history: History;
}

interface OnboardExtraTeamPageState {
    schoolWorkloadConfig?: SchoolWorkloadConfig;
}

class OnboardExtraTeamsPage extends Component<OnboardExtraTeamPageProps & DispatchProps, OnboardExtraTeamPageState> {

    constructor(props: OnboardExtraTeamPageProps & DispatchProps) {
        super(props);
        this.state = {
            schoolWorkloadConfig: undefined
        };
    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId)
        {

            const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);

            this.setState({
                schoolWorkloadConfig
            });
        }
    }

    async componentDidUpdate(prevProps: Readonly<OnboardExtraTeamPageProps & DispatchProps>, prevState: OnboardExtraTeamPageState): Promise<void> {
    }

    private save = async (): Promise<boolean> => {
        if (this.state.schoolWorkloadConfig === undefined) {
            return false;
        }

        const updatedConfig = _.cloneDeep(this.state.schoolWorkloadConfig);

        const savedSchoolWorkloadConfig = await this.props.apiService.putSchoolConfigJson(this.props.tenantId, this.props.schoolCode, updatedConfig);
        this.setState({
            schoolWorkloadConfig: savedSchoolWorkloadConfig
        });

        await this.props.dispatch(Actions.showMessageBar("Saved Extra Teams options to config", MessageBarType.success));

        return true;
    }

    private onEnableAllStaffTeamChange = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        if (this.state.schoolWorkloadConfig !== undefined && checked !== undefined) {
            this.state.schoolWorkloadConfig.extraTeamsConfig.enableAllStaffTeam = checked;
            this.setState({
                schoolWorkloadConfig: this.state.schoolWorkloadConfig
            });
        }
    };

    private onEnableAllTeacherTeamChange = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        if (this.state.schoolWorkloadConfig !== undefined && checked !== undefined) {
            this.state.schoolWorkloadConfig.extraTeamsConfig.enableAllTeachersTeam = checked;
            this.setState({
                schoolWorkloadConfig: this.state.schoolWorkloadConfig
            });
        }
    };

    public render(): JSX.Element {

        return (
            <Fragment>
                <OnboardHelpBox currentTimelineItemKey={"extra-teams"}/>
                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                <div className="onboard-timeline-content">
                                    <div className="flex-item--flex-1 flex-column flex--align-items-center">
                                        <h3>Extra Teams</h3>

                                        <Stack tokens={{childrenGap: 10}}>
                                            <Checkbox
                                                label="Enable All Staff Team"
                                                checked={this.state.schoolWorkloadConfig?.extraTeamsConfig.enableAllStaffTeam}
                                                onChange={this.onEnableAllStaffTeamChange}/>
                                            <Checkbox
                                                label="Enable All Teachers Team"
                                                checked={this.state.schoolWorkloadConfig?.extraTeamsConfig.enableAllTeachersTeam}
                                                onChange={this.onEnableAllTeacherTeamChange}/>
                                        </Stack>

                                    </div>
                                </div>
                                <OnboardNavigation currentTimelineItemKey={"extra-teams"} timelineItems={timelineItems} completeItem={this.save}
                                                   enableNext={true} enableSave={false} history={this.props.history}
                                                   tenantId={this.props.tenantId} schoolCode={this.props.schoolCode}/>

                            </Fragment>
                        );
                    }}
                </OnboardTimeline>
            </Fragment>
        )
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardExtraTeamPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(OnboardExtraTeamsPage)